import { useGetUmbracoTafDeliveryApiV1BookingObjectsItemObjectIdSuspense } from '@shared/integrations/umbraco-taf-delivery-api/features/object-booking/object-booking';
import { Link } from '@tanstack/react-router';
import { IBooking } from '@shared/integrations/taf-api/v2/models';
import { Card, CardBody, CardFooter, CardMedia, CardTitle } from '@shared/components/Card.tsx';
import Markup from '@shared/components/Markup.tsx';
import { dateTimeStringToDate } from '@my-pages/features/object-booking/utils/calendarUtils.ts';
import CancelBookingButton from '@my-pages/features/object-booking/components/CancelBookingButton.tsx';
import Feature from '@shared/features/feature-flags/components/Feature';
import { FeatureFlag } from '@shared/_legacy/api/umbraco-api';

interface IAccommodationBookingItemProps {
    booking: IBooking;
}

const AccommodationBookingItem = ({ booking }: IAccommodationBookingItemProps) => {
    const { data } = useGetUmbracoTafDeliveryApiV1BookingObjectsItemObjectIdSuspense(booking.objectId!);
    const calcGuests = () => {
        let beds = 0;
        if (data?.metaData?.numberOfDoubleBeds) beds += data.metaData?.numberOfDoubleBeds * 2;
        if (data?.metaData?.numberOfSingleBeds) beds += data.metaData?.numberOfSingleBeds;
        if (data?.metaData?.numberOfBunkBeds) beds += data.metaData?.numberOfBunkBeds * 2;
        return beds;
    };
    return (
        <Card className='h-100 rounded-xxl'>
            {data?.imageUrl ? (
                <CardMedia>
                    <img
                        src={`${data.imageUrl}?width=700&height=700`}
                        className='rounded-xxl'
                        width={700}
                        height={700}
                        alt=''
                    />
                </CardMedia>
            ) : null}

            <CardBody className='d-flex flex-column gap-2'>
                <header>
                    <div className='kicker font-size-sm'>{data?.location}</div>
                    <CardTitle variant='h3'>{data?.name}</CardTitle>
                </header>
                <ul className='list-unstyled d-flex flex-wrap column-gap-1 text-muted'>
                    <div className='list-bullet'>{calcGuests()} gäster</div>
                    {data?.metaData && data.metaData.numberOfRooms ? <div className='list-bullet'>{data.metaData.numberOfRooms} sovrum</div> : null}
                    {data?.metaData && data.metaData.numberOfBathRooms ? <div className='list-bullet'>{data.metaData.numberOfBathRooms} badrum</div> : null}
                </ul>
                {data?.description ? <Markup content={data.description} /> : null}
                <div className='d-flex flex-wrap gap-2 justify-content-end'>
                    <Link
                        to={data?.url}
                        className='btn btn-primary'
                    >
                        Om boendet
                    </Link>
                    <Link
                        to={data?.url}
                        hash={'cancellationPolicy'}
                        className='btn btn-light '
                    >
                        Bokningsvillkor
                    </Link>
                    <Feature feature={FeatureFlag.CANCEL_OBJECT_BOOKING}>
                        {booking ? (
                            <CancelBookingButton
                                booking={booking}
                                object={data}
                            />
                        ) : null}
                    </Feature>
                </div>
            </CardBody>
            <CardFooter>
                <div className='d-flex flex-column gap-2'>
                    <div className='d-flex justify-content-between gap-2 text-muted'>
                        <span>Period</span>
                        <span>
                            {booking.startDate ? dateTimeStringToDate(booking.startDate) : 'N/A'} - {booking.endDate ? dateTimeStringToDate(booking.endDate) : 'N/A'}
                        </span>
                    </div>
                    <div className='d-flex justify-content-between gap-2 text-muted'>
                        <span>Längd</span>
                        <span>7 dagar</span>
                    </div>
                    <div className='d-flex justify-content-between gap-2 text-muted'>
                        <span>Summa</span>
                        <span>{booking.totalPrice} kr</span>
                    </div>
                </div>
            </CardFooter>
        </Card>
    );
};

export default AccommodationBookingItem;
